import React from 'react';
import Footer from './footer';
import Header from './header';
import { Reveal, Scramble, d } from './motion';

type PageProps = {
    label: string;
    title: string;
    intro?: React.ReactNode;
    children: React.ReactNode;
};

/** Shell for inner pages: same header, grain and footer as home, with an indexed title block. */
function Page({ label, title, intro, children }: PageProps) {
    return (
        <div className="site">
            <div className="grain" aria-hidden="true" />
            <Header />
            <main className="shell pt-32 sm:pt-44 pb-24 sm:pb-32">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-x-8">
                    <div className="lg:col-span-3 mono text-[#7a7873] mb-8 lg:mb-0 lg:pt-4">
                        <Scramble text={label} />
                    </div>
                    <Reveal className="lg:col-span-9">
                        <h1 className="display text-[clamp(2.6rem,6.4vw,6.5rem)]">
                            <span className="mask"><span style={d(100)}>{title}</span></span>
                        </h1>
                        {intro && (
                            <div className="fade mt-8 text-[#7a7873] text-lg leading-relaxed max-w-[38rem]" style={d(450)}>
                                {intro}
                            </div>
                        )}
                        <div className="rule mt-14 sm:mt-20" style={d(300)} />
                    </Reveal>
                </div>

                <div className="grid grid-cols-1 lg:grid-cols-12 gap-x-8">
                    <Reveal className="lg:col-span-9 lg:col-start-4">
                        <div className="fade pt-12 sm:pt-16" style={d(600)}>
                            {children}
                        </div>
                    </Reveal>
                </div>
            </main>
            <Footer />
        </div>
    );
}

export default Page;
